import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';

const STORAGE_KEY = 'cookie-consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const val = localStorage.getItem(STORAGE_KEY);
    setVisible(val !== 'accepted');
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-0 right-0 z-50">
      <div className="container mx-auto px-4">
        <div className="rounded-2xl p-4 md:p-5 glass-effect border border-primary/30 shadow-xl flex flex-col md:flex-row gap-3 md:items-center md:justify-between">
          <p className="text-sm text-muted-foreground">
            We use cookies for basic analytics and to improve your experience. You can opt out anytime.
          </p>
          <div className="flex gap-2 justify-end">
            <Button
              variant="outline"
              onClick={() => {
                localStorage.setItem(STORAGE_KEY, 'rejected');
                setVisible(false);
              }}
            >
              Reject
            </Button>
            <Button
              className="gradient-brand text-white"
              onClick={() => {
                localStorage.setItem(STORAGE_KEY, 'accepted');
                setVisible(false);
              }}
            >
              Accept
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;


